import { Section } from '@/enums';
import { RiskToleranceAnswer } from '@/api/enums';

export default {
    applicationError: null,
    hasAnyValueChangeInEditMode: false, // Have values been touched in edit mode?
    language: '',
    screenSource: null,
    settings: {
        emailRequiredForExistingCustomer: null,
        emailRequiredForNewCustomer: null,
        mobileAppUrl: null,
        onlineAppointmentSchedulerUrl: null,
        minInvestmentHorizon: null,
        maxInvestmentHorizon: null,
        minInvestmentAmount: null,
        maxInvestmentAmountViaInput: null,
        maxInvestmentAmountViaSlider: null,
        infoBoxTimeout: null,
    }, // Holds app config like redirect URLs.. fetched from back end
    iframeParams: {}, // Contains infos about the host page via iframe-resizer
    viewport: null, // Contains infos about the current viewport via vue-breakpoint-component
    isInEditMode: false, // Is app in edit mode? Used by MBK mobile banking integration
    editConfiguration: null, // Holds the form values for re-building the form in edit mode
    openSections: [Section.INVESTMENT_GOALS],
    investmentObjective: null,
    previousInvestmentStrategySelected: null,
    investmentStrategySelected: null,
    investmentStrategyRecommendedBasedOnRiskTolerance: null,
    investmentStrategyRecommendedBasedOnInvestmentHorizon: null,
    investmentTopic: null,
    investmentRegion: null,
    otherInvestments: null,
    investmentHorizon: null,
    investmentAmount: null,
    selectedDetailsFilterType: null,
    selectedDetailsSubFilterType: null,
    modelPortfolioDetails: null,
    modelPortfolioPositions: null,
    riskToleranceBlock1SelectedAnswer: RiskToleranceAnswer.NOT_ANSWERED,
    riskToleranceBlock2SelectedAnswer: RiskToleranceAnswer.NOT_ANSWERED,
    riskToleranceBlock3SelectedAnswer: RiskToleranceAnswer.NOT_ANSWERED,
    investmentDiagramResponse: null,
    emailAddress: null,
    userIsCustomer: null,
};
